import { render, staticRenderFns } from "./MentionsMenu.vue?vue&type=template&id=a4bbab1e&scoped=true&"
import script from "./MentionsMenu.vue?vue&type=script&lang=js&"
export * from "./MentionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./MentionsMenu.vue?vue&type=style&index=0&id=a4bbab1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bbab1e",
  null
  
)

export default component.exports